import { render, staticRenderFns } from "./LogoStacked.vue?vue&type=template&id=f6533d36&"
import script from "./LogoStacked.vue?vue&type=script&lang=js&"
export * from "./LogoStacked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports